import React from 'react';
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid2,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../../components/atom/SearchInput';
import { formatDateTimeInVenueTz } from '../../../helpers/formatDateTime';

const FILTER_CONTROL_SX = { '& .MuiOutlinedInput-root': { height: 40 } };
const FILTER_LABEL_SX = { mb: 0.5, textAlign: 'left' };

function WaitlistFilters({
    shows,
    timeslots,
    selectedShowId,
    selectedTimeslotId,
    onShowChange,
    onTimeslotChange,
    search,
    setSearch,
    setParams,
    limit,
    loadingFilterOptions,
    onlyFulfillable,
    onFulfillableChange,
    onlyNeverNotified,
    onNeverNotifiedChange,
}) {
    const { t } = useTranslation();

    return (
        <Grid2 size={{ xs: 12 }}>
            <Paper variant="outlined" sx={{ p: 2 }}>
                <Stack spacing={2}>
                    <Grid2 container spacing={2} sx={{ alignItems: 'flex-end' }}>
                        <Grid2 size={{ xs: 12, md: 3 }}>
                            <InputLabel sx={FILTER_LABEL_SX}>
                                {t('waitlist.filters.show')}
                            </InputLabel>
                            <FormControl
                                fullWidth
                                size="small"
                                hiddenLabel
                                disabled={loadingFilterOptions || shows.length === 0}
                                sx={FILTER_CONTROL_SX}
                            >
                                <Select value={selectedShowId} onChange={onShowChange}>
                                    {shows.map((show) => (
                                        <MenuItem key={show.id} value={String(show.id)}>
                                            {show.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 3 }}>
                            <InputLabel sx={FILTER_LABEL_SX}>
                                {t('waitlist.filters.timeslot')}
                            </InputLabel>
                            <FormControl
                                fullWidth
                                size="small"
                                hiddenLabel
                                disabled={
                                    !selectedShowId ||
                                    loadingFilterOptions ||
                                    timeslots.length === 0
                                }
                                sx={FILTER_CONTROL_SX}
                            >
                                <Select value={selectedTimeslotId} onChange={onTimeslotChange}>
                                    <MenuItem value="">
                                        {t('waitlist.filters.allTimeslots')}
                                    </MenuItem>
                                    {timeslots.map((timeslot) => (
                                        <MenuItem key={timeslot.id} value={String(timeslot.id)}>
                                            {formatDateTimeInVenueTz(timeslot.startTime)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={FILTER_LABEL_SX}>
                                {t('waitlist.filters.search')}
                            </InputLabel>
                            <Box sx={FILTER_CONTROL_SX}>
                                <SearchInput
                                    fullWidth
                                    variant="outlined"
                                    search={search}
                                    setSearch={setSearch}
                                    setParams={setParams}
                                    limit={limit}
                                    placeholder={t('waitlist.filters.searchPlaceholder')}
                                />
                            </Box>
                        </Grid2>
                    </Grid2>

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2 }}
                        flexWrap="wrap"
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={onlyFulfillable}
                                    onChange={onFulfillableChange}
                                />
                            }
                            label={t('waitlist.filters.fulfillableOnly')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={onlyNeverNotified}
                                    onChange={onNeverNotifiedChange}
                                />
                            }
                            label={t('waitlist.filters.neverNotifiedOnly')}
                        />
                    </Stack>
                </Stack>
            </Paper>
        </Grid2>
    );
}

export default WaitlistFilters;
